import { render, staticRenderFns } from "./SheriffViewLista.vue?vue&type=template&id=23c818ff&"
import script from "./SheriffViewLista.vue?vue&type=script&lang=js&"
export * from "./SheriffViewLista.vue?vue&type=script&lang=js&"
import style0 from "./SheriffViewLista.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "SheriffViewLista.vue"
export default component.exports